import { Component, OnInit } from '@angular/core';
import PerfectScrollbar from 'perfect-scrollbar';
import { TokenService } from '../../../core/services/token.service';
import { EnvService } from '../../../core/services/env.service';
import { AuthService } from '../../../core/services/auth.service';
import { Router } from '@angular/router';
import { CODITIONS_CODE } from 'src/app/core/utils/configurations'

declare const $: any;

// Metadata
export interface ChildrenItems {
    path: string;
    title: string;
    ab: string;
    type?: string;
    ability?: string;
}

export interface RouteInfo {
    path: string;
    title: string;
    type: string;
    icontype: string;
    collapse?: string;
    children?: ChildrenItems[];
    ability?: string;
    conditions?: string[];
    hidden?: boolean;
}

// Menu Items
export const ROUTES: Array<RouteInfo> = [
    {
        path: 'dashboard',
        title: 'Tablero',
        type: 'link',
        icontype: 'dashboard',
    },
    {
        path: 'consular-register',
        title: 'Registro Consular',
        type: 'link',
        icontype: 'app_registration',
        conditions: [CODITIONS_CODE.PERMANENT, CODITIONS_CODE.TRANSIT]
    },
    {
        path: 'requests',
        title: 'Mis Solicitudes',
        type: 'link',
        icontype: 'reorder',
        conditions: [CODITIONS_CODE.PERMANENT, CODITIONS_CODE.TRANSIT]
    },
    {
        path: 'procedures/management',
        title: 'Trámites',
        type: 'link',
        icontype: 'assignment',
        hidden: true,
        conditions: [CODITIONS_CODE.PERMANENT, CODITIONS_CODE.TRANSIT]
    },
    {
        path: 'procedures',
        title: 'Trámites',
        type: 'link',
        icontype: 'assignment',
        hidden: true,
        conditions: [CODITIONS_CODE.PERMANENT, CODITIONS_CODE.TRANSIT]
    },
];

@Component({
    selector: 'app-sidebar-cmp',
    templateUrl: 'sidebar.component.html',
})

export class SidebarComponent implements OnInit {

    public menuItems: any[];
    public appName = this.env.getOne('app');
    public user = this.token.get();
    ps: any;

    constructor(
        private token: TokenService,
        private env: EnvService,
        private router: Router,
        public auth: AuthService,
    ) { }

    isMobileMenu() {
        if ($(window).width() > 991) {
            return false;
        }
        return true;
    }
    ngOnInit() {
        this.menuItems = ROUTES.filter(menuItem => menuItem && !menuItem.hidden);

        if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
            const elemSidebar = <HTMLElement>document.querySelector('.sidebar .sidebar-wrapper');
            this.ps = new PerfectScrollbar(elemSidebar);
        }

        if (this.user.nationalityType.name === 'EXTRANJERO') {
            this.menuItems.find(o => o.path === 'consular-register').title = 'Registro Inicial';
        }
    }
    updatePS(): void  {
        if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
            this.ps.update();
        }
    }
    isMac(): boolean {
        let bool = false;
        if (navigator.platform.toUpperCase().indexOf('MAC') >= 0 || navigator.platform.toUpperCase().indexOf('IPAD') >= 0) {
            bool = true;
        }
        return bool;
    }
    logOut(event: MouseEvent) {
        event.preventDefault();
        this.auth.logOut();
    }
}
